import axios from '../utils/axiosConfig';
import { qiniuConfig } from '../config/qiniu.config';

export const qiniuService = {
  getUploadToken: async () => {
    try {
      const response = await axios.get('/qiniu/upload-token');
      return response.data.data.uploadToken;
    } catch (error) {
      throw new Error('获取上传凭证失败');
    }
  },

  uploadFile: async ({ file, onProgress }) => {
    const token = await qiniuService.getUploadToken();
    if (!token) {
      throw new Error('获取上传凭证失败');
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('token', token);

    try {
      const response = await axios.post(qiniuConfig.uploadHost, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
          onProgress?.({ percent });
        }
      });

      return {
        key: response.data.key,
        url: qiniuConfig.getFullURL(response.data.key)
      };
    } catch (error) {
      throw new Error('文件上传失败');
    }
  }
};